import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  LoginRefreshTokenGQL,
  LoginRefreshTokenMutation,
  LoginV2GQL,
  LoginV2Mutation,
} from '../../generated/eveportal-api/graphql';
import { MutationResult } from 'apollo-angular';

@Injectable({
  providedIn: 'root',
})
export class AuthService {

  constructor(
    private loginMutation: LoginV2GQL,
    private loginRefreshTokenGQL: LoginRefreshTokenGQL
  ) {}

  performAuthenticatedFlow(refreshToken: string) : Observable<MutationResult<LoginRefreshTokenMutation>> {
    return this.loginRefreshTokenGQL.mutate({ refreshToken });
  };

  login(user: string, password: string, deviceName: string): Observable<MutationResult<LoginV2Mutation>> {
    return this.loginMutation.mutate({ user, password, deviceName });
  }
}
